export default {
  props: {
    rejectInfo: {}
  },

  data() {
    return {
      dialogTableVisible: false,
      isShowSeeMoreDialog: false
    };
  },

  methods: {
    open() {
      this.dialogTableVisible = !this.dialogTableVisible;
    }

  }
};